import { render, staticRenderFns } from "./Homepage2.vue?vue&type=template&id=ff672996&scoped=true&"
import script from "./Homepage2.vue?vue&type=script&lang=js&"
export * from "./Homepage2.vue?vue&type=script&lang=js&"
import style0 from "./Homepage2.vue?vue&type=style&index=0&id=ff672996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff672996",
  null
  
)

export default component.exports